module.exports = __webpack_public_path__ + "img/luminance-saturation.ebf4cf62.png";